import fileDownload from "js-file-download";

class DownloadX {

  static Excel(blob, filename){
    const getBlob = new Blob([blob], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    fileDownload(getBlob, `${filename}.xlsx`);
  }

  static Zip(blob, filename){
    const getBlob = new Blob([blob], { type: "application/zip" });
    fileDownload(getBlob, `${filename}.zip`);
  }

  /**
   * Download a PDF with an explicit filename (supports remote URL or base64 payload).
   * @param {{url?: String, base64?: String, filename?: String}|String} src
   * @param {String} [filename]
   */
  static async PDF(src, filename){
    let url = typeof src === "string" ? src : src?.url;
    let base64 = typeof src === "object" ? src?.base64 : undefined;
    let name = filename || (typeof src === "object" ? src?.filename : undefined) || "download.pdf";
    if(!name.toLowerCase().endsWith(".pdf")){
      name = `${name}.pdf`;
    }

    if(base64){
      let binary = atob(base64);
      let bytes = new Uint8Array(binary.length);
      for(let i = 0; i < binary.length; i++){
        bytes[i] = binary.charCodeAt(i);
      }
      fileDownload(new Blob([bytes], { type: "application/pdf" }), name);
      return;
    }

    if(!url) return;

    try{
      let res = await fetch(url);
      let blob = await res.blob();
      fileDownload(blob, name);
    }catch(e){
      window.open(url);
    }
  }

}

export default DownloadX;